class EntitySubscription {
  getSubscription(trigger) {
    return this.getSubscriptions()[trigger];
  }
  getResponseMapper(trigger) {
    return this.getResponseMappers()[trigger];
  }
}
export {
  EntitySubscription
};
//# sourceMappingURL=EntitySubscription.js.map
